import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './header.css'
import {
   Button,
   Form,
   FormControl,
   Nav,
   Navbar,
   NavDropdown
} from 'react-bootstrap';
import {
    Link,
    NavLink,
    useLocation
} from 'react-router-dom';
import { HomeRounded } from '@mui/icons-material';
import ResumeData from '../../utils/ResumeData';
import CustomButton from '../Button/Button';
import AddTaskIcon from '@mui/icons-material/AddTask';
const Header = (props) => {
    const pathName=useLocation();
  return (
    <Navbar expand='lg' sticky='top' className='header'>
        <Nav.Link as={NavLink} to='/' className='header_navlink'>
            <Navbar.Brand className='header_home'>
                <HomeRounded/>
            </Navbar.Brand>
        </Nav.Link>
        <Navbar.Toggle/>
        <Navbar.Collapse>
            <Nav className='header_left'>
                <Nav.Link as={NavLink} to='/' className={pathName.pathname=='/'?'header_link-active':'header_link'}>
                    Resume
                    {console.log(pathName.pathname=='/')}
                </Nav.Link>
                <Nav.Link as={NavLink} to='/portfolio' className={pathName.pathname=='/portfolio'?'header_link-active':'header_link'}>
                    Portfolio
                </Nav.Link>
            </Nav>
            <div className='header_right'>
                {
                    Object.keys(ResumeData.socials).map((key)=>(
                        <a href={ResumeData.socials[key].link} target='_blank'>{ResumeData.socials[key].icon}</a>
                    ))
                }
                <CustomButton text={'Hire Me'} icon={<AddTaskIcon/>}/>
            </div>
        </Navbar.Collapse>
    </Navbar>
  )
}

export default Header